import React from 'react';
import { ExpandableDropdownItem } from './ExpandableDropdownItem';
import type { MenuItem } from '../../../types';
import styles from '../DesktopNavigation.module.scss';

interface DropdownItemProps {
  item: MenuItem;
  expandedItems: Set<string>;
  onToggleExpanded: (itemId: string) => void;
  onItemClick: (item: MenuItem) => void;
}

export const DropdownItem = ({ 
  item, 
  expandedItems, 
  onToggleExpanded, 
  onItemClick,
}: DropdownItemProps) => {
  // Handle divider items - simple horizontal line
  if (item.type === 'divider') {
    return <li key={item.id} className={styles.divider}></li>;
  }

  // Handle expandable items with nested children
  if (item.type === 'expandable') {
    const isExpanded = expandedItems.has(item.id);
    return (
      <ExpandableDropdownItem
        item={item}
        isExpanded={isExpanded}
        onToggle={onToggleExpanded}
        onItemClick={onItemClick}
      />
    );
  }

  // Handle regular clickable items (link or action)
  // Use testId from item if available, otherwise fall back to legacy format: item.id + 'MenuDropdownOption'
  const testId = item.testId || `${item.id}MenuDropdownOption`;
  
  return (
    <li>
      <button 
        onClick={() => onItemClick(item)} 
        className={styles.menuItem}
        data-testid={testId}
      >
        <div className={styles.itemContent}>
          <span className={styles.primaryLabel}>{item.label}</span>
          {/* Show secondary label if provided */}
          {item.secondaryLabel && (
            <span className={styles.secondaryLabel}>{item.secondaryLabel}</span>
          )}
        </div>
      </button>
    </li>
  );
}; 